module.exports = __webpack_public_path__ + "static/media/call-to-action-dark-blue-bokeh@phone.64d260d1.jpg";